import { ButtonTypes } from '@paywithextend/components'
import cn from 'classnames'
import Button from 'ext-ui/components/Button/Button'
import React from 'react'
import { useSelector } from 'react-redux'
import SvgFilterFunnel from 'src/components/Svgs/SvgFilterFunnel'
import { selectFeatureFlaggerFromState } from 'src/redux/selectors/data/featureFlagger.selectors'

import styles from './UtilityToolbarFilterButton.style'

interface UtilityToolbarFilterButtonProps {
  onFilterButtonClick: () => void
  selectedFiltersCount: number
}

const UtilityToolbarFilterButton: React.FC<UtilityToolbarFilterButtonProps> = (
  props,
): React.ReactElement => {
  const { show_automated_expense_review: showAutomatedExpenseReview } =
    useSelector(selectFeatureFlaggerFromState)

  return (
    <div
      className={cn('UtilityToolbarFilterButton', 'container', {
        selected: props.selectedFiltersCount > 0,
      })}
      css={styles}
    >
      <Button
        data-testid={'filtersButton'}
        type={ButtonTypes.button}
        variant={'toolbar'}
        dropShadow={false}
        onClick={(): void => {
          props.onFilterButtonClick()
        }}
      >
        <span className={'UtilityToolbarFilterButton icon'}>
          <SvgFilterFunnel />
        </span>
      </Button>
      {showAutomatedExpenseReview && (
        <div
          className={cn('countBadge', {
            visible: props.selectedFiltersCount > 0,
          })}
        >
          {props.selectedFiltersCount}
        </div>
      )}
    </div>
  )
}

export default UtilityToolbarFilterButton
